var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"facilities-count-with-owner-indicator"},[_c('IsOwnerIndicator',{attrs:{"isOwner":_vm.isOwner,"height":_vm.height,"tooltip":_vm.tooltip}}),_c('span',[_vm._v(" "+_vm._s(_vm.isOwner ? _vm.facilitiesCount.owner : _vm.facilitiesCount.not_owner)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }